import React, { useMemo, useState } from 'react';
import { Form, InputNumber, Typography, Alert, Segmented } from 'antd';
import { currencyInputProps, decimalInputProps } from '../../../utils/numberInputMask';
import { simularDelivery, formatBRL } from '../../../utils/simuladores';
import SimuladorResultado from './SimuladorResultado';

const { Text, Paragraph } = Typography;

const MODO_OPTIONS = [
    { label: 'Buscar no local', value: 'buscar' },
    { label: 'Cozinhar', value: 'cozinhar' },
    { label: 'Outra comida', value: 'outra' },
];

function DeliveryForm() {
    const [values, setValues] = useState({
        precoPrato: null,
        taxaEntrega: null,
        gorjeta: null,
        cupom: null,
        modo: 'buscar',
        gastoIr: null,
        custoCenario: null,
        vezesPorMes: 4,
    });

    const resultado = useMemo(() => simularDelivery(values), [values]);

    const onChange = (field) => (val) => {
        setValues((prev) => ({ ...prev, [field]: val }));
    };

    return (
        <div className="simulador-form">
            <Alert
                type="info"
                showIcon
                className="simulador-dica"
                message="Como usar"
                description="Some o que o app cobra no delivery e escolha o que você faria no lugar: buscar, cozinhar ou comer outra coisa."
                style={{ marginBottom: 16 }}
            />

            <Form layout="vertical">
                <Text strong style={{ display: 'block', marginBottom: 8 }}>
                    Quanto custa pedir
                </Text>
                <Form.Item label="Preço do pedido">
                    <InputNumber
                        {...currencyInputProps({ min: 0 })}
                        value={values.precoPrato}
                        onChange={onChange('precoPrato')}
                        size="large"
                    />
                </Form.Item>
                <Form.Item label="Taxa de entrega" extra="Se for grátis, deixe em branco ou zero">
                    <InputNumber
                        {...currencyInputProps({ min: 0 })}
                        value={values.taxaEntrega}
                        onChange={onChange('taxaEntrega')}
                        size="large"
                    />
                </Form.Item>
                <Form.Item label="Gorjeta">
                    <InputNumber
                        {...currencyInputProps({ min: 0 })}
                        value={values.gorjeta}
                        onChange={onChange('gorjeta')}
                        size="large"
                    />
                </Form.Item>
                <Form.Item label="Cupom / desconto">
                    <InputNumber
                        {...currencyInputProps({ min: 0 })}
                        value={values.cupom}
                        onChange={onChange('cupom')}
                        size="large"
                    />
                </Form.Item>

                <div className="simulador-opcao-bloco" style={{ marginTop: 8 }}>
                    <Text strong style={{ display: 'block', marginBottom: 8 }}>
                        Em vez de pedir, o que você faria?
                    </Text>
                    <Segmented
                        block
                        value={values.modo}
                        onChange={onChange('modo')}
                        options={MODO_OPTIONS}
                        style={{ marginBottom: 12, width: '100%' }}
                    />

                    {values.modo === 'buscar' && (
                        <>
                            <Paragraph type="secondary" style={{ fontSize: 13, marginBottom: 12 }}>
                                Compara a mesma comida: no delivery entram taxa e gorjeta; buscando, só o pedido + o gasto para ir.
                            </Paragraph>
                            <Form.Item
                                label="Gasto para ir buscar"
                                extra="Uber, combustível, estacionamento… Se for a pé ou de graça, deixe 0"
                            >
                                <InputNumber
                                    {...currencyInputProps({ min: 0 })}
                                    value={values.gastoIr}
                                    onChange={onChange('gastoIr')}
                                    size="large"
                                    placeholder="Ex.: 12,00"
                                />
                            </Form.Item>
                        </>
                    )}

                    {values.modo === 'cozinhar' && (
                        <Form.Item
                            label="Quanto sairia nos ingredientes de uma refeição parecida?"
                            extra="Ex.: R$ 15 a R$ 30 para uma refeição em casa"
                        >
                            <InputNumber
                                {...currencyInputProps({ min: 0 })}
                                value={values.custoCenario}
                                onChange={onChange('custoCenario')}
                                size="large"
                                placeholder="Ex.: 20,00"
                            />
                        </Form.Item>
                    )}

                    {values.modo === 'outra' && (
                        <Form.Item
                            label="Quanto custaria essa outra opção?"
                            extra="Ex.: marmita, padaria, lanche da esquina"
                        >
                            <InputNumber
                                {...currencyInputProps({ min: 0 })}
                                value={values.custoCenario}
                                onChange={onChange('custoCenario')}
                                size="large"
                                placeholder="Ex.: 18,00"
                            />
                        </Form.Item>
                    )}
                </div>

                <Form.Item label="Quantas vezes por mês você faria isso?" style={{ marginTop: 8 }}>
                    <InputNumber
                        {...decimalInputProps(0, { min: 1, max: 90 })}
                        value={values.vezesPorMes}
                        onChange={onChange('vezesPorMes')}
                        size="large"
                    />
                </Form.Item>
            </Form>

            {resultado && (
                <SimuladorResultado
                    veredicto={resultado.veredicto}
                    stats={[
                        { title: 'Custo delivery', value: formatBRL(resultado.custoDelivery) },
                        { title: resultado.labelStat, value: formatBRL(resultado.custoComparacao) },
                        { title: 'Impacto no mês', value: formatBRL(resultado.impactoMensal) },
                    ]}
                />
            )}
        </div>
    );
}

export default DeliveryForm;
